import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { buildCanonicalUrl, normalizeSeoPath, shouldNoindexPath } from '@/seo';
interface CanonicalTagProps {
    path?: string;
}
const CanonicalTag: React.FC<CanonicalTagProps> = ({ path }) => {
    const location = useLocation();
    useEffect(() => {
        const canonicalPath = path || location.pathname;
        const normalizedPath = normalizeSeoPath(canonicalPath);
        if (shouldNoindexPath(normalizedPath)) {
            const existingCanonical = document.querySelector('link[rel="canonical"]');
            existingCanonical?.remove();
            return;
        }
        const canonicalUrl = buildCanonicalUrl(normalizedPath);
        const existingCanonical = document.querySelector('link[rel="canonical"]');
        if (existingCanonical) {
            existingCanonical.remove();
        }
        const canonicalLink = document.createElement('link');
        canonicalLink.rel = 'canonical';
        canonicalLink.href = canonicalUrl;
        document.head.appendChild(canonicalLink);
        return () => {
            if (canonicalLink.parentNode) {
                canonicalLink.parentNode.removeChild(canonicalLink);
            }
        };
    }, [location.pathname, path]);
    return null;
};
export default CanonicalTag;
